export enum FilterOperatorType {
  Eq = '=',
  BiggerThan = '>',
  LessThan = '<',
}
